<template>
  <div class="copyright-area bg-primary">
    <div class="container">
      <div class="row">
        <p>
          © <span>Nylo</span> is Proudly Owned by
          <a href="https://hibotheme.com/" target="_blank">HiboTheme</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CopyRight",
});
</script>
